import { render, staticRenderFns } from "./video_2.vue?vue&type=template&id=408b8e11&scoped=true&"
var script = {}
import style0 from "./video_2.vue?vue&type=style&index=0&id=408b8e11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408b8e11",
  null
  
)

export default component.exports